import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiClient } from "../service/tekkr-service";
import { useProject } from "../project";

export function useDeleteWorkstreamMutation(workstreamId: string) {
    const { project } = useProject();
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: async () => {
            await apiClient.deleteWorkstream({
                params: { projectId: project.id, workstreamId },
            });
            await queryClient.refetchQueries({ queryKey: ["project", project.id] });
        },
    });
}
